import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { noop } from '@prisjakt/ui-base';
import { AppContext } from '@prisjakt/ui-app-context';
import actions from '../../actions/mobile-menu';

import * as S from './styles';

class MobileButton extends React.PureComponent {
  toggleMenu = () => {
    const { open, closeMenu, openMenu, handleOnClick } = this.props;

    if (open) {
      closeMenu();
    } else {
      openMenu();
      handleOnClick();
    }
  };

  render() {
    const { t } = this.context;

    return (
      <S.MenuButton
        onClick={this.toggleMenu}
        aria-label={t('header', 'mobile-menu.title')}
        data-test="MobileMenuButton"
      >
        <S.MenuIcon size={32} />
        <S.MenuText>{t('header', 'mobile-menu.title')}</S.MenuText>
      </S.MenuButton>
    );
  }
}

const { bool, func } = PropTypes;
MobileButton.propTypes = {
  open: bool,
  openMenu: func,
  closeMenu: func,
  handleOnClick: func,
};

MobileButton.defaultProps = {
  open: true,
  closeMenu: noop,
  openMenu: noop,
  handleOnClick: noop,
};

MobileButton.contextType = AppContext;

export default connect(
  state => state.areas.navigation.mobileMenu,
  actions
)(MobileButton);
